import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getTotalProductsShipped = {
  name: "getTotalProductsShipped" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
